import { freddyTheme } from '@coolblue-development/freddy';
export const hamburgerLinkStyles = {
    '&:focus-visible': {
        boxShadow: 'none',
        span: {
            outline: 'none',
            boxShadow: `0 0 0 2px ${freddyTheme.color.border.interactiveFocused}`,
            borderRadius: freddyTheme.borderRadius[100],
            padding: `0 ${freddyTheme.spacing[100]}`,
        },
    },
};
//# sourceMappingURL=HamburgerMenu.styles.js.map